import PropTypes from 'prop-types';
import React from 'react';
import classes from './style.module.scss';

export default function Radio({
  value = '',
  label = '',
  onChange,
  checked = false
}) {
  return (
    <label className={classes.container} htmlFor={`${label}-${value}`}>
      {label}
      <input
        type="radio"
        checked={checked}
        onChange={onChange}
        id={`${label}-${value}`}
        value={value}
      />
      <span className={classes.checkmark} />
    </label>
  );
}

Radio.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
};
